import type { ReactNode } from "react";
import { ChangeText } from "~/components/layout/text/ChangeText";

export const Bold = ({ children }: { children: ReactNode }) => {
    return <ChangeText weight="semibold">{children}</ChangeText>;
};
